import { Box, Container } from '@mui/material'
import React from 'react'
import NavbarCatalogo from './Catalogo/NavBarCatalogo'
import Sites from '../helpers/sitesLinks'
import { useLocation, useNavigate } from 'react-router-dom'
import Notifications from './Notifications'
import { isMaintenanceMode } from '../helpers/maintenanceMode'

const styles = {
    boxHeader: {
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    greenDiv: {
        width: "100vw",
        lineHeight: "20px",
        padding: "5px",
        fontSize: "13px",
        backgroundColor: "#9bcd65",
        color: "black",
        fontWeight: "400",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        letterSpacing: "0.2rem"
    },
}

const Header = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const matchRouteWithParams = (path, route) => {
        if (route !== "/catalogo-details/:productId") {
            return path === route
        }
        const regex = new RegExp(route.replace(":productId", "[^/]+"));
        return regex.test(path);
    };


    const site = Sites.urls.some(route => matchRouteWithParams(location.pathname, route))
        ? "/catalogo"
        : "/products";


    if (isMaintenanceMode) {
        return (
            <Box display="flex" justifyContent="center" flexDirection="column" sx={styles.boxHeader}>
                <div style={{ ...styles.greenDiv, cursor: "default" }}>PORTAL EXCLUSIVO PARA LIBRERÍAS</div>
            </Box>
        )
    }

    return (
        <>
            <Box display="flex" justifyContent="center" flexDirection="column"  sx={site === "/catalogo" ? styles.boxHeader : {}}>
                {location.pathname !== "/lista-clientes" && !location.pathname.startsWith("/reportes") && <div style={styles.greenDiv} onClick={() => navigate("/login")}>PORTAL EXCLUSIVO PARA LIBRERÍAS</div>}
                <NavbarCatalogo />
            </Box>
            <Container>
                <Notifications />
            </Container>
        </>
    )
}

export default Header